import React, { useState, useEffect } from 'react';
import ContactApp from '@adsk/dh-contact-react-components/ContactApp';
import ContactContext from '@adsk/dh-contact-react-components/ContactApp/ContactContext';
import { oxygenCheckSignin } from '../utils/utilOxygen';
import { availableLanguages } from './App.config';
import './App.scss';

const App = () => {
  const [userData, setUserDate] = useState(null);
  const [oxygenUserData, setOxygenUserData] = useState({});
  const [sessionSig, setSessionSig] = useState(null);
  const [isContactWidgetModalOpen, setIsContactWidgetModalOpen] = useState(
    false,
  );

  // Preset props
  const contactAppProps = {
    originApp: 'Contact Widget',
    callbackKey: process.env.REACT_APP_CALLBACK_KEY,
    tier: process.env.REACT_APP_TIER,
    updateAppState: () => {},
    isContactWidgetModalOpen,
  };

  const handleMessage = (e) => {
    const { data } = e;
    if (typeof data === 'string') {
      if (data === 'contact-widget-modal-open')
        setIsContactWidgetModalOpen(true);
      if (data === 'contact-widget-modal-close')
        setIsContactWidgetModalOpen(false);
      let message = {};
      try {
        message = JSON.parse(data);
      } catch (e) {
        return;
      }
      const { isUserData, firstName, lastName, email, userid } = message;
      if (isUserData) {
        if (firstName && lastName && email && userid) {
          setUserDate({
            MESSAGE: 'SUCCESS',
            CONSUMER_RESPONSE_DATA: {
              last: lastName,
              language: contactAppProps.language || 'en_US',
              fullname: `${firstName} ${lastName}`,
              first: firstName,
              email: email,
              userid,
            },
          });
        } else if (userData) setUserDate(null);
      }
    }
  };

  useEffect(() => {
    window.setOxygenUserData = setOxygenUserData;
    oxygenCheckSignin({ sessionSig, setSessionSig });

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  // Get other props from url query
  for (const [key, value] of new URLSearchParams(
    window.location.search,
  ).entries()) {
    if (value === 'true') contactAppProps[key] = true;
    else if (value === 'false') contactAppProps[key] = false;
    else contactAppProps[key] = value;
  }

  // Check language fallback
  if (
    !contactAppProps.language ||
    !availableLanguages.includes(contactAppProps.language)
  )
    contactAppProps.language = 'en_US';

  // Provide default props if they are not provided by url query
  if (!contactAppProps.skillId) contactAppProps.skillId = 'PRE';
  if (!contactAppProps.type) contactAppProps.type = 'eStore - Purchasing';
  if (!contactAppProps.topic) contactAppProps.topic = 'Purchasing Help';
  if (!contactAppProps.contactType) contactAppProps.contactType = 'presales';
  if (!contactAppProps.sourceUrl)
    contactAppProps.sourceUrl = 'www.autodesk.com';

  // return (
  //   <div data-wat-link-section="contact-widget">
  //     <ContactContext.Provider>
  //       {userData ? ( // Force the whole Contact App to re-render
  //         <ContactApp {...contactAppProps} userData={userData} />
  //       ) : (
  //         <ContactApp {...contactAppProps} />
  //       )}
  //     </ContactContext.Provider>
  //   </div>
  // );
  return (
    <div data-wat-link-section="contact-widget">
      <ContactContext.Provider>
        <ContactApp {...contactAppProps} userData={oxygenUserData} />
      </ContactContext.Provider>
    </div>
  );
};

export default App;
